import { useContext } from "react";
import { LinkComponentProjectDialogContext, PageNewState } from ".";

export const useLinkComponentProjectDialogState = () => {
  const { pageState, setPageState } = useContext(
    LinkComponentProjectDialogContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
